module.exports = __webpack_public_path__ + "img/icon_personalizacao_dados_comunicacao.8665e60f.svg";